/* eslint-disable react-hooks/exhaustive-deps */
import {
  Add,
  ArrowLeft,
  DeleteSharp,
  EditSharp,
  RemoveRedEye,
  UploadFile
} from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Page from "src/components/Page";
import styled from "styled-components";
import moment from "moment";
import { notification } from "src/utils/messages";
import {
  insertPrimeNotification,
  updatePrimeNotification,
  deletenotification,
  getReadPrimeNotificationData
} from "src/api/commonapi";
import DataTable from "react-data-table-component";
import { Routes } from "../constant/api_url";
import Deletemodal from "./DeleteModal";
import Label from "../components/Label";
import { CSVLink } from "react-csv";
import { LoadingButton } from "@mui/lab";
import { CKEditor } from "ckeditor4-react";
import { fetchPrimeNotificationList } from "src/utils/common";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import CustomLoader from "src/components/CustomLoader";

function Notification() {
  const readNotificationModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [notificationList, setNotificationList] = useState([]);
  const [newNotificationList, setNewNotificationList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [response, setresponse] = useState(0);
  // 0- All, 1- insert, 2-update
  const [page, setPage] = useState(0);
  const [setfile, setFile] = useState({});
  const [fileimage, setfileimage] = useState();
  const imageTypes = ["png", "jpg", "jpeg", "gif", "webp"];
  const videoTypes = ["mp3", "wav", "ogg"];

  const handlePageChange = (newPageValue) => {
    setPage(newPageValue);
  };
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [isFormSubmit, setIsFormSubmit] = useState(false);

  const NotificationStatus = [
    { label: "All", value: 0 },
    { label: "Open ", value: 1 },
    { label: "Close", value: 2 }
  ];
  const NotificationType = [
    { label: "All", value: -1 },
    { label: "Photo ", value: 0 },
    { label: "Audio", value: 1 },
    { label: "Video", value: 2 },
    { label: "Question and Answer", value: 3 }
  ];
  const NotificationTo = [
    { label: "All", value: 0 },
    { label: "Orange Tick ", value: 7 },
    { label: "Not Orange Tick", value: 8 }
  ];
  const [filtereddata, setFilteredData] = useState({
    notificationStatus: 0,
    notificationType: -1,
    n_to: 0,
    search: "",
    startDate: "",
    endDate: ""
  });

  const getYoutubeVideoId = (url) => {
    if (!url) return null;
    const regExp = /^.*(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]{11}).*/;
    const match = url.match(regExp);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
  };

  const [formData, setFormData] = useState({
    n_title: "",
    n_description: "<p></p>",
    n_link: "",
    n_button_title: "",
    n_image: "",
    n_video: "",
    n_question: "",
    n_answer: "<p></p>",
    // 0-Photo: "", 1-Audio: "", 2-Video: "", 3-Question and Answer
    n_type: "0",
    n_to: "0",
    s_date: moment().format("DD-MM-YYYY"),
    e_date: "",
    notification_send_type: "0",
    n_date_time: "",
    n_send_to: "2", // 0-all, 1-LT, 2-members
    n_for_type: "4", // 0 - LVB , 1- State, 2- City, 3- Chapter, 4- Prime
    n_for_id: "",
    n_status: "1", // status: 0-Inactive, 1-Active
    show_on_home: 0
  });

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1
  });

  const getAcceptType = (type) => {
    switch (type) {
      case "0":
        return "image/*,.jpg,.jpeg,.png,.gif";
      case "1":
        return "audio/*,.mp3,.wav,.ogg";
      case 0:
        return "image/*,.jpg,.jpeg,.png,.gif";
      case 1:
        return "audio/*,.mp3,.wav,.ogg";
      default:
        return "";
    }
  };

  const resetFormData = () => {
    setFormData({
      n_title: "",
      n_description: "<p></p>",
      n_link: "",
      n_button_title: "",
      n_image: "",
      n_audio: "",
      n_video: "",
      n_question: "",
      n_answer: "<p></p>",
      n_type: "0",
      n_to: "0",
      s_date: moment().format("DD-MM-YYYY"),
      e_date: "",
      notification_send_type: "0",
      n_date_time: "",
      n_send_to: "2",
      n_for_type: "4",
      n_for_id: "",
      n_status: "1",
      show_on_home: 0
    });
  };

  const handleFormSubmit = async (newData = undefined) => {
    try {
      let fData = new FormData();

      if (formData != undefined && formData.n_id != undefined) {
        // Update the form data
        setIsFormSubmit(true);
        if (formData.n_type == 0 || formData.n_type == 1) {
          let fileExtension = "";
          if (formData.n_image) {
            fileExtension = formData.n_image.split(".").pop().toLowerCase();
          }
          let isValidFile = false;
          if (formData.n_type == 0) {
            isValidFile = imageTypes.includes(fileExtension);
          } else if (formData.n_type == 1) {
            isValidFile = videoTypes.includes(fileExtension);
          }

          const isScheduleNotification = formData.notification_send_type == 0;
          let isDateTimeValid = true;
          // Validation for scheduled notifications
          if (isScheduleNotification && formData.n_date_time) {
            const notificationDateTime = moment(formData.n_date_time, "DD-MM-YYYY hh:mm A");
            const startDate = moment(formData.s_date, "DD-MM-YYYY").startOf("day"); // Set start of day
            const endDate = moment(formData.e_date, "DD-MM-YYYY").endOf("day"); // Set end of day

            isDateTimeValid =
              notificationDateTime.isSameOrAfter(startDate) &&
              notificationDateTime.isSameOrBefore(endDate);

            if (!isDateTimeValid) {
              let notify = notification({
                type: "error",
                message: "Notification Send Date & Time must be between Start Date and End Date.",
                position: "top"
              });
              notify();
              setIsFormSubmit(false);
              return;
            }
          }
          if (
            (!isValidFile && (setfile == "" || Object.keys(setfile).length === 0)) ||
            formData.n_title == "" ||
            formData.n_description == "" ||
            formData.s_date == "" ||
            formData.e_date == "" ||
            (isScheduleNotification && formData.n_date_time == "") ||
            !isDateTimeValid
          ) {
            let notify = notification({
              type: "error",
              message: "Please enter all required fields to submit",
              position: "top"
            });
            notify();
            setIsFormSubmit(false);
          } else {
            fData.append("n_title", formData.n_title);
            fData.append("n_description", formData.n_description);
            fData.append("n_link", formData.n_link);
            fData.append("n_button_title", formData.n_button_title);
            fData.append("n_image", setfile.file);
            fData.append("n_type", formData.n_type);
            fData.append("n_to", formData.n_to);
            fData.append("s_date", formData.s_date);
            fData.append("e_date", formData.e_date);
            fData.append("notification_send_type", formData.notification_send_type);
            fData.append("n_date_time", formData.n_date_time);
            fData.append("n_send_to", formData.n_send_to);
            fData.append("n_for_type", formData.n_for_type);
            fData.append("n_for_id", formData.n_for_id);
            fData.append("n_status", formData.n_status);
            fData.append("n_id", formData?.n_id);
            fData.append("show_on_home", formData.show_on_home);
            const resp = await updatePrimeNotification(fData);
            let notify = notification({
              type: resp.status == 0 ? "error" : "success",
              message: resp.message,
              position: "top"
            });
            notify();
            resetFormData();
            setPage(0);
            getNotificationList();
            setfileimage();
            setFile({});
            setIsFormSubmit(false);
          }
        } else if (formData.n_type == 2) {
          const isScheduleNotification = formData.notification_send_type == 0;
          if (
            formData.n_video == "" ||
            formData.n_title == "" ||
            formData.n_description == "" ||
            formData.s_date == "" ||
            formData.e_date == "" ||
            (isScheduleNotification && formData.n_date_time == "") ||
            (formData.n_video == "" && getYoutubeVideoId(formData?.n_video) == null)
          ) {
            let notify = notification({
              type: "error",
              message: "Please enter all required fields to submit",
              position: "top"
            });
            notify();
            setIsFormSubmit(false);
          } else {
            fData.append("n_title", formData.n_title);
            fData.append("n_description", formData.n_description);
            fData.append("n_link", formData.n_link);
            fData.append("n_button_title", formData.n_button_title);
            fData.append("n_video", formData.n_video);
            fData.append("n_type", formData.n_type);
            fData.append("n_to", formData.n_to);
            fData.append("s_date", formData.s_date);
            fData.append("e_date", formData.e_date);
            fData.append("notification_send_type", formData.notification_send_type);
            fData.append("n_date_time", formData.n_date_time);
            fData.append("n_send_to", formData.n_send_to);
            fData.append("n_for_type", formData.n_for_type);
            fData.append("n_for_id", formData.n_for_id);
            fData.append("n_status", formData.n_status);
            fData.append("n_id", formData?.n_id);
            fData.append("show_on_home", formData.show_on_home);
            const resp = await updatePrimeNotification(fData);
            let notify = notification({
              type: resp.status == 0 ? "error" : "success",
              message: resp.message,
              position: "top"
            });
            notify();
            resetFormData();
            setPage(0);
            getNotificationList();
            setfileimage();
            setIsFormSubmit(false);
            setFile({});
          }
        } else if (formData.n_type == 3) {
          const isScheduleNotification = formData.notification_send_type == 0;
          if (
            formData.n_question == "" ||
            formData.n_answer == "" ||
            formData.s_date == "" ||
            formData.e_date == "" ||
            (isScheduleNotification && formData.n_date_time == "")
          ) {
            let notify = notification({
              type: "error",
              message: "Please enter all required fields to submit",
              position: "top"
            });
            notify();
            setIsFormSubmit(false);
          } else {
            fData.append("n_question", formData.n_question);
            fData.append("n_answer", formData.n_answer);
            fData.append("n_link", formData.n_link);
            fData.append("n_button_title", formData.n_button_title);
            fData.append("n_type", formData.n_type);
            fData.append("n_to", formData.n_to);
            fData.append("s_date", formData.s_date);
            fData.append("e_date", formData.e_date);
            fData.append("notification_send_type", formData.notification_send_type);
            fData.append("n_date_time", formData.n_date_time);
            fData.append("n_send_to", formData.n_send_to);
            fData.append("n_for_type", formData.n_for_type);
            fData.append("n_for_id", formData.n_for_id);
            fData.append("n_status", formData.n_status);
            fData.append("n_id", formData?.n_id);
            fData.append("show_on_home", formData.show_on_home);
            const resp = await updatePrimeNotification(fData);
            let notify = notification({
              type: resp.status == 0 ? "error" : "success",
              message: resp.message,
              position: "top"
            });
            notify();
            resetFormData();
            setPage(0);
            getNotificationList();
            setfileimage();
            setIsFormSubmit(false);
            setFile({});
          }
        } else {
          let notify = notification({
            type: "error",
            message: "something went wrong please try again later",
            position: "top"
          });
          notify();
          setIsFormSubmit(false);
        }
      } else {
        // Insert the form data
        setIsFormSubmit(true);
        if (formData.n_type == 0 || formData.n_type == 1) {
          const isScheduleNotification = formData.notification_send_type == 0;
          let isDateTimeValid = true;

          // Validation for scheduled notifications
          if (isScheduleNotification && formData.n_date_time) {
            const notificationDateTime = moment(formData.n_date_time, "DD-MM-YYYY hh:mm A");
            const startDate = moment(formData.s_date, "DD-MM-YYYY").startOf("day"); // Set start of day
            const endDate = moment(formData.e_date, "DD-MM-YYYY").endOf("day"); // Set end of day

            isDateTimeValid =
              notificationDateTime.isSameOrAfter(startDate) &&
              notificationDateTime.isSameOrBefore(endDate);

            if (!isDateTimeValid) {
              let notify = notification({
                type: "error",
                message: "Notification Send Date & Time must be between Start Date and End Date.",
                position: "top"
              });
              notify();
              setIsFormSubmit(false);
              return;
            }
          }

          if (
            setfile == "" ||
            setfile == undefined ||
            Object.keys(setfile).length === 0 ||
            formData.n_title == "" ||
            formData.n_description == "" ||
            formData.s_date == "" ||
            formData.e_date == "" ||
            (isScheduleNotification && formData.n_date_time == "") ||
            !isDateTimeValid
          ) {
            let notify = notification({
              type: "error",
              message: "Please enter all required fields to submit",
              position: "top"
            });
            notify();
            setIsFormSubmit(false);
          } else {
            // API Call
            fData.append("n_title", formData.n_title);
            fData.append("n_description", formData.n_description);
            fData.append("n_link", formData.n_link);
            fData.append("n_button_title", formData.n_button_title);
            fData.append("n_image", setfile.file);
            fData.append("n_type", formData.n_type);
            fData.append("n_to", formData.n_to);
            fData.append("s_date", formData.s_date);
            fData.append("e_date", formData.e_date);
            fData.append("notification_send_type", formData.notification_send_type);
            fData.append("n_date_time", formData.n_date_time);
            fData.append("n_send_to", formData.n_send_to);
            fData.append("n_for_type", formData.n_for_type);
            fData.append("n_for_id", formData.n_for_id);
            fData.append("n_status", formData.n_status);
            fData.append("show_on_home", formData.show_on_home);
            const resp = await insertPrimeNotification(fData);
            let notify = notification({
              type: resp.status == 0 ? "error" : "success",
              message: resp.message,
              position: "top"
            });
            notify();
            resetFormData();
            setPage(0);
            getNotificationList();
            setfileimage();
            setIsFormSubmit(false);
            setFile({});
          }
        } else if (formData.n_type == 2) {
          const isScheduleNotification = formData.notification_send_type == 0;
          let isDateTimeValid = true;

          if (isScheduleNotification && formData.n_date_time) {
            const notificationDateTime = moment(formData.n_date_time, "DD-MM-YYYY hh:mm A");
            const startDate = moment(formData.s_date, "DD-MM-YYYY").startOf("day"); // Set start of day
            const endDate = moment(formData.e_date, "DD-MM-YYYY").endOf("day"); // Set end of day

            isDateTimeValid =
              notificationDateTime.isSameOrAfter(startDate) &&
              notificationDateTime.isSameOrBefore(endDate);

            if (!isDateTimeValid) {
              let notify = notification({
                type: "error",
                message: "Notification Send Date & Time must be between Start Date and End Date.",
                position: "top"
              });
              notify();
              setIsFormSubmit(false);
              return;
            }
          }

          if (
            formData.n_video == "" ||
            formData.n_title == "" ||
            formData.n_description == "" ||
            formData.s_date == "" ||
            formData.e_date == "" ||
            (isScheduleNotification && formData.n_date_time == "") ||
            (formData.n_video != "" && getYoutubeVideoId(formData?.n_video) == null) ||
            !isDateTimeValid
          ) {
            let notify = notification({
              type: "error",
              message: "Please enter all required fields to submit",
              position: "top"
            });
            notify();
            setIsFormSubmit(false);
          } else {
            fData.append("n_title", formData.n_title);
            fData.append("n_description", formData.n_description);
            fData.append("n_link", formData.n_link);
            fData.append("n_button_title", formData.n_button_title);
            fData.append("n_video", formData.n_video);
            fData.append("n_type", formData.n_type);
            fData.append("n_to", formData.n_to);
            fData.append("s_date", formData.s_date);
            fData.append("e_date", formData.e_date);
            fData.append("notification_send_type", formData.notification_send_type);
            fData.append("n_date_time", formData.n_date_time);
            fData.append("n_send_to", formData.n_send_to);
            fData.append("n_for_type", formData.n_for_type);
            fData.append("n_for_id", formData.n_for_id);
            fData.append("n_status", formData.n_status);
            fData.append("show_on_home", formData.show_on_home);
            const resp = await insertPrimeNotification(fData);
            let notify = notification({
              type: resp.status == 0 ? "error" : "success",
              message: resp.message,
              position: "top"
            });
            notify();
            resetFormData();
            setPage(0);
            getNotificationList();
            setfileimage();
            setIsFormSubmit(false);
            setFile({});
          }
        } else if (formData.n_type == 3) {
          const isScheduleNotification = formData.notification_send_type == 0;
          let isDateTimeValid = true;

          if (isScheduleNotification && formData.n_date_time) {
            const notificationDateTime = moment(formData.n_date_time, "DD-MM-YYYY hh:mm A");
            const startDate = moment(formData.s_date, "DD-MM-YYYY").startOf("day"); // Set start of day
            const endDate = moment(formData.e_date, "DD-MM-YYYY").endOf("day"); // Set end of day

            isDateTimeValid =
              notificationDateTime.isSameOrAfter(startDate) &&
              notificationDateTime.isSameOrBefore(endDate);

            if (!isDateTimeValid) {
              let notify = notification({
                type: "error",
                message: "Notification Send Date & Time must be between Start Date and End Date.",
                position: "top"
              });
              notify();
              setIsFormSubmit(false);
              return;
            }
          }

          if (
            formData.n_question == "" ||
            formData.n_answer == "" ||
            formData.s_date == "" ||
            formData.e_date == "" ||
            (isScheduleNotification && formData.n_date_time == "") ||
            !isDateTimeValid
          ) {
            let notify = notification({
              type: "error",
              message: "Please enter all required fields to submit",
              position: "top"
            });
            notify();
            setIsFormSubmit(false);
          } else {
            // API Call
            fData.append("n_question", formData.n_question);
            fData.append("n_answer", formData.n_answer);
            fData.append("n_link", formData.n_link);
            fData.append("n_button_title", formData.n_button_title);
            fData.append("n_type", formData.n_type);
            fData.append("n_to", formData.n_to);
            fData.append("s_date", formData.s_date);
            fData.append("e_date", formData.e_date);
            fData.append("notification_send_type", formData.notification_send_type);
            fData.append("n_date_time", formData.n_date_time);
            fData.append("n_send_to", formData.n_send_to);
            fData.append("n_for_type", formData.n_for_type);
            fData.append("n_for_id", formData.n_for_id);
            fData.append("n_status", formData.n_status);
            fData.append("show_on_home", formData.show_on_home);
            const resp = await insertPrimeNotification(fData);
            let notify = notification({
              type: resp.status == 0 ? "error" : "success",
              message: resp.message,
              position: "top"
            });
            notify();
            resetFormData();
            setPage(0);
            getNotificationList();
            setfileimage();
            setIsFormSubmit(false);
            setFile({});
          }
        } else {
          let notify = notification({
            type: "error",
            message: "something went wrong please try again later",
            position: "top"
          });
          notify();
          setIsFormSubmit(false);
        }
      }
    } catch (e) {
      console.log("Error", e);
    }
  };

  const notificationdelete = async (n_id) => {
    const resp = await deletenotification(n_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message,
      position: "top"
    });
    notify();

    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };

  const getNotificationList = async () => {
    setIsLoading(true);
    setNotificationList(await fetchPrimeNotificationList(loginUser.u_type));
    setIsLoading(false);
  };

  useEffect(async () => {
    getNotificationList();
  }, [response]);

  const [readNotificationDataModal, setReadNotificationDataModal] = useState(false);
  const [readNotificationList, setReadNotificationList] = useState([]);

  // Open modal with notification ID
  const openModalWithNotification = async (n_id) => {
    setReadNotificationDataModal(true); // Open modal

    try {
      setIsLoading2(true);
      const resp = await getReadPrimeNotificationData(n_id);
      setIsLoading2(false);
      if (resp.status === 1) {
        setReadNotificationList(resp.data);
      } else {
        setReadNotificationList([]);
      }
    } catch (error) {
      console.error("Error fetching notification data:", error);
    }
  };

  // Close modal and reset state
  const closeModal = () => {
    setReadNotificationDataModal(false);
    setReadNotificationList([]);
  };

  const readNotificationDetailColumns = [
    {
      name: "Member Name",
      selector: (row) => row?.m_name,
      sortable: true
    },
    {
      name: "Notification Read Date",
      selector: (row) => row?.r_date,
      sortable: true
    },
    {
      name: "Status",
      selector: (row) => (
        <>
          <Label
            variant="ghost"
            color="success"
            style={{
              marginBottom: "10px",
              display: "flex",
              fontSize: "16px"
            }}
          >
            Read
          </Label>
        </>
      ),
      sortable: true
    }
  ];

  const export_readNotificationDetailColumns = [
    { label: "Member Name", key: "m_name" },
    { label: "Notification Read Date", key: "r_date" }
  ];

  const expo_columns = [
    { label: "No", key: "n_id" },
    { label: "Type", key: "Notification_type" },
    { label: "Notification To", key: "n_to" },
    { label: "Title", key: "n_title" },
    { label: "Description", key: "n_description" },
    { label: "URL", key: "n_link" },
    { label: "Button Title", key: "n_button_title" },
    { label: "Question", key: "n_question" },
    { label: "Answer", key: "n_answer" },
    { label: "Start Date", key: "s_date" },
    { label: "End Date", key: "e_date" },
    { label: "Notification Send Date & Time", key: "n_date_time" },
    { label: "Created Date", key: "timestamp" }
  ];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row, index) => index + 1,
      sortable: true,
      width: "70px"
    },
    {
      name: "Type",
      wrap: true,
      width: "90px",
      selector: (row) => row.Notification_type
    },
    {
      name: "Image/Audio/Video",
      wrap: true,
      width: "150px",
      cell: (row) => {
        if (row.n_type === 1) {
          return (
            <audio controls src={`${Routes.API_HOSTNAME}images/notification/${row.n_image}`} />
          );
        } else if (row.n_type === 0) {
          return (
            <img
              src={`${Routes.API_HOSTNAME}images/notification/${row.n_image}`}
              alt="img"
              width="100"
            />
          );
        } else if (row.n_type === 2) {
          return row.n_video;
        } else {
          return "-";
        }
      }
    },
    {
      name: "Notification To",
      wrap: true,
      width: "150px",
      selector: (row) => NotificationTo?.find((opt) => opt?.value == row?.n_to)?.label || "-",
      sortable: true
    },
    {
      name: "Title",
      wrap: false,
      width: "150px",
      cell: (row) => {
        const content = row.n_title ?? "-";
        return (
          <div title={content}>{content.length > 30 ? content.slice(0, 30) + "..." : content}</div>
        );
      },
      sortable: true
    },
    {
      name: "URL",
      wrap: true,
      width: "120px",
      selector: (row) => (row.n_link != null && row.n_link != "" ? row.n_link : "-"),
      sortable: true
    },
    {
      name: "Button Title",
      wrap: true,
      width: "120px",
      selector: (row) =>
        row.n_button_title != null && row.n_button_title != "" ? row.n_button_title : "-",
      sortable: true
    },
    {
      name: "Question",
      wrap: false,
      width: "150px",
      cell: (row) => {
        const content = row.n_question ?? "-";
        return (
          <div title={content}>{content.length > 30 ? content.slice(0, 30) + "..." : content}</div>
        );
      },
      sortable: true
    },
    {
      name: "Start Date",
      wrap: true,
      width: "120px",
      selector: (row) => row.s_date,
      sortable: true
    },
    {
      name: "End Date",
      selector: (row) => row.e_date,
      wrap: true,
      width: "120px",
      sortable: true
    },
    {
      name: "Notification Send Date & Time",
      selector: (row) => row.n_date_time,
      wrap: true,
      width: "120px",
      sortable: true
    },
    {
      name: "Created Date",
      selector: (row) => formatDate(row.timestamp),
      wrap: true,
      width: "120px",
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      width: "150px",
      cell: (row) => (
        <>
          <button
            onClick={() => {
              setDvisible({ mval: true, id: row.n_id });
            }}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="Delete">
              <IconButton>
                <DeleteSharp color="error" />
              </IconButton>
            </Tooltip>
          </button>
          <button
            onClick={() => {
              setPage(2);
              setFormData(row);
              setfileimage();
            }}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="Edit">
              <IconButton>
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </button>
          <button
            onClick={() => openModalWithNotification(row.n_id)}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="See Assign Member List">
              <IconButton>
                <RemoveRedEye color="success" />
              </IconButton>
            </Tooltip>
          </button>
        </>
      )
    }
  ];
  const ExpandableRow = ({ data }) => {
    return (
      <>
        <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
          <p>
            <b>Description:</b>
          </p>
          <div dangerouslySetInnerHTML={{ __html: data?.n_description ?? "-" }} />
        </div>
        <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
          <p>
            <b>Answer:</b>
          </p>
          <div dangerouslySetInnerHTML={{ __html: data?.n_answer ?? "-" }} />
        </div>
      </>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    // Ensure correct date format
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    // Extract day, month, year
    let day = String(date.getDate()).padStart(2, "0");
    let month = String(date.getMonth() + 1).padStart(2, "0");
    let year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  function htmlToPlainText(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  const formattedCSVData = newNotificationList?.map((row, index) => ({
    n_id: index + 1,
    notification_type: row.notification_type,
    n_to: NotificationTo?.find((opt) => opt?.value == row?.n_to)?.label || "-",
    n_title: row.n_title,
    n_description: htmlToPlainText(row.n_description || ""),
    n_link: row.n_link,
    n_button_title: row.n_button_title,
    n_question: row.n_question,
    n_answer: htmlToPlainText(row.n_answer || ""),
    s_date: row.s_date,
    e_date: row.e_date,
    n_date_time: row.n_date_time,
    timestamp: formatDate(row.timestamp)
  }));

  const filterData = () => {
    const filterByNotificationType = (notification) => {
      return (
        filtereddata.notificationType == -1 || notification.n_type === filtereddata.notificationType
      );
    };

    const filterByNotificationTo = (notification) => {
      return filtereddata.n_to == 0 || notification.n_to === filtereddata.n_to;
    };

    const filterByOpenClose = (notification) => {
      if (filtereddata.notificationStatus === 1) {
        // Open notifications: future notifications only
        return moment(notification.e_date, "DD-MM-YYYY").isSameOrAfter(moment(), "day");
      }
      if (filtereddata.notificationStatus === 2) {
        // Closed notifications: past notifications only
        return moment(notification.e_date, "DD-MM-YYYY").isBefore(moment(), "day");
      }
      return true;
    };

    const filterBySearchType = (notification) => {
      let searchFilterText = filtereddata.search.toLowerCase();
      return (
        filtereddata.search == "" ||
        notification?.n_question?.toLowerCase().includes(searchFilterText) ||
        notification?.n_answer?.toLowerCase().includes(searchFilterText) ||
        notification?.n_title?.toLowerCase().includes(searchFilterText) ||
        notification?.n_description?.toLowerCase().includes(searchFilterText) ||
        notification?.n_link?.toLowerCase().includes(searchFilterText) ||
        notification?.n_button_title?.toLowerCase().includes(searchFilterText)
      );
    };

    const nNotification = notificationList?.filter(
      (notification) =>
        filterByNotificationType(notification) &&
        filterByNotificationTo(notification) &&
        filterByOpenClose(notification) &&
        filterBySearchType(notification)
    );

    setNewNotificationList(nNotification);
  };

  useEffect(() => {
    filterData();
  }, [filtereddata, notificationList]);

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={notificationdelete} />

      <Page title="Notification | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography variant="h4" gutterBottom className="mb-0">
              Notification
            </Typography>
            {page === 0 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  handlePageChange(1);
                  setIsFormSubmit(false);
                }}
              >
                <Add sx={{ fontSize: "20px", marginRight: "5px" }} />
                Add Notification
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="primary"
                disabled={isFormSubmit}
                onClick={() => {
                  resetFormData();
                  setPage(0);
                  setfileimage();
                }}
              >
                <ArrowLeft sx={{ fontSize: "20px", marginRight: "5px" }} />
                Back
              </Button>
            )}
          </Stack>

          {page != 0 ? (
            <>
              <Card style={{ padding: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      className=""
                      style={{ textAlign: "center" }}
                    >
                      {page === 1 ? "Add New Notification" : "Edit Notification"}
                    </Typography>
                    <hr style={{ marginBottom: "0", marginTop: "0" }} />
                  </Grid>
                  <Grid item xs={12}>
                    <FormLabel> Select Type</FormLabel>
                    <Stack spacing={3}>
                      <RadioGroup
                        row
                        defaultValue={0}
                        value={formData?.n_type}
                        onChange={(e) => {
                          if (page == 1) {
                            setFormData({
                              ...formData,
                              n_type: e.target.value,
                              n_to: "0",
                              n_title: "",
                              n_description: "",
                              n_link: "",
                              n_button_title: "",
                              n_image: "",
                              n_audio: "",
                              n_video: "",
                              n_question: "",
                              n_answer: "",
                              s_date: moment().format("DD-MM-YYYY"),
                              e_date: "",
                              notification_send_type: "0",
                              n_date_time: "",
                              n_send_to: "2",
                              n_for_type: "4",
                              n_for_id: "",
                              n_status: "1",
                              show_on_home: 0
                            });
                            setFile({});
                            setfileimage();
                          } else {
                            setFormData({
                              ...formData,
                              n_type: e.target.value
                            });
                          }
                        }}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="n_type"
                      >
                        <FormControlLabel value={0} control={<Radio />} label="Photo" />
                        <FormControlLabel value={1} control={<Radio />} label="Audio" />
                        <FormControlLabel value={2} control={<Radio />} label="Video" />
                        <FormControlLabel
                          value={3}
                          control={<Radio />}
                          label="Question and Answer"
                        />
                      </RadioGroup>
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <FormLabel>Notification To</FormLabel>
                    <Stack spacing={3}>
                      <RadioGroup
                        row
                        defaultValue={0}
                        value={formData?.n_to}
                        onChange={(e) => {
                          if (page == 1) {
                            setFormData({
                              ...formData,
                              n_to: e.target.value
                            });
                            setFile({});
                            setfileimage();
                          } else {
                            setFormData({
                              ...formData,
                              n_to: e.target.value
                            });
                          }
                        }}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="n_to"
                      >
                        <FormControlLabel value={0} control={<Radio />} label="All" />
                        <FormControlLabel value={7} control={<Radio />} label="Orange Tick" />
                        <FormControlLabel value={8} control={<Radio />} label="Not Orange Tick" />
                      </RadioGroup>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Stack>
                      <FormControl component="fieldset">
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                name="show_on_home"
                                checked={formData.show_on_home == 0 ? false : true}
                                onChange={(e) => {
                                  let x = 0;
                                  if (e.target.checked == true) x = 1;

                                  setFormData({
                                    ...formData,
                                    [e.target.name]: x
                                  });
                                }}
                                value="0"
                              />
                            }
                            label="Show On Home Screen"
                          />
                        </FormGroup>
                      </FormControl>
                    </Stack>
                  </Grid>
                  {
                    // display Title and description if selected type is not Question and Answer
                    formData?.n_type != 3 && (
                      <>
                        <Grid item xs={12}>
                          <Stack spacing={3}>
                            <TextField
                              required
                              type="text"
                              label="Title"
                              fullWidth
                              value={formData?.n_title}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  n_title: e.target.value
                                });
                              }}
                            />
                          </Stack>
                        </Grid>

                        <Grid item xs={12}>
                          <FormLabel> Description</FormLabel>
                          <CKEditor
                            initData={formData?.n_description}
                            config={{
                              allowedContent: true,
                              extraPlugins: "colorbutton,font", // adds font + color options
                              removeButtons: "", // keep all defaults
                              colorButton_colors:
                                // 🔹 Default CKEditor palette (taken from docs)
                                "000000,993300,333300,003300,003366,000080,333399,333333," +
                                "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                                "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                                "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                                "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                                // 🔹 Your extra theme colors (example: brand palette)
                                "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                            }}
                            onChange={(event) => {
                              const data = event.editor.getData();
                              setFormData((prevData) => ({
                                ...prevData,
                                n_description: data
                              }));
                            }}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <Stack spacing={3}>
                            <TextField
                              type="text"
                              label="URL"
                              fullWidth
                              value={formData?.n_link}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  n_link: e.target.value
                                });
                              }}
                            />
                          </Stack>
                        </Grid>
                        <Grid item xs={6}>
                          <Stack spacing={3}>
                            <TextField
                              type="text"
                              label="Button Title"
                              fullWidth
                              value={formData?.n_button_title}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  n_button_title: e.target.value
                                });
                              }}
                            />
                          </Stack>
                        </Grid>
                      </>
                    )
                  }
                  {(formData?.n_type == 0 || formData?.n_type == 1) && (
                    <Grid item xs={12}>
                      <Button
                        component="label"
                        variant="contained"
                        color="primary"
                        tabIndex={-1}
                        sx={{ textTransform: "none", p: "10px" }}
                        startIcon={<UploadFile />}
                      >
                        Click to Upload file
                        <VisuallyHiddenInput
                          type="file"
                          required
                          multiple={false}
                          accept={getAcceptType(formData?.n_type)}
                          onChange={(event) => {
                            const uploadedFile = event.currentTarget.files[0];

                            // Check if file exists and validate its size
                            let maxSize = 2 * 1024 * 1024;

                            // Apply 10MB if audio
                            if (formData.n_type == 1) {
                              maxSize = 10 * 1024 * 1024;
                            }

                            const allowedImageTypes = [
                              "image/jpeg",
                              "image/png",
                              "image/jpg",
                              "image/gif"
                            ];
                            const allowedAudioTypes = ["audio/mpeg", "audio/wav", "audio/ogg"];

                            if (uploadedFile) {
                              const fileType = uploadedFile.type;

                              if (formData.n_type == 0 && !allowedImageTypes.includes(fileType)) {
                                let notify = notification({
                                  type: "error",
                                  message: "Please upload a valid image file.",
                                  position: "top"
                                });
                                notify();
                                return;
                              } else if (
                                formData.n_type == 1 &&
                                !allowedAudioTypes.includes(fileType)
                              ) {
                                let notify = notification({
                                  type: "error",
                                  message: "Please upload a valid audio file.",
                                  position: "top"
                                });
                                notify();
                                return;
                              }

                              if (uploadedFile.size > maxSize) {
                                let notify = notification({
                                  type: "error",
                                  message: `File size exceeds ${
                                    maxSize / (1024 * 1024)
                                  }MB. Please upload a smaller file.`,
                                  position: "top"
                                });
                                notify();
                                return;
                              }
                            }

                            // If valid, update the state
                            setFile({ file: uploadedFile });
                            setfileimage(URL.createObjectURL(uploadedFile));
                          }}
                        />
                      </Button>

                      {/* Display uploaded Image / Audio */}
                      {page == 1 &&
                        (fileimage !== undefined ? (
                          <div style={{ marginTop: "10px" }}>
                            {formData?.n_type == 0 ? (
                              <>
                                <h4>Image Preview</h4>
                                <div className="position-relative">
                                  <img
                                    src={fileimage}
                                    alt="Uploaded file preview"
                                    style={{
                                      width: "450px",
                                      objectFit: "contain",
                                      height: "250px",
                                      boxShadow: "0 0 5px #ccc",
                                      borderRadius: "5px"
                                    }}
                                  />
                                </div>
                              </>
                            ) : formData?.n_type == 1 ? (
                              <>
                                <h4>Audio Preview</h4>
                                <audio controls src={fileimage} />
                              </>
                            ) : null}
                          </div>
                        ) : (
                          ""
                        ))}
                      {page == 2 &&
                        (fileimage !== undefined ? (
                          <div style={{ marginTop: "10px" }}>
                            {formData?.n_type == 0 ? (
                              <>
                                <h4>Image Preview</h4>
                                <div className="position-relative">
                                  <img
                                    src={fileimage}
                                    alt="Uploaded file preview"
                                    style={{
                                      width: "450px",
                                      objectFit: "contain",
                                      height: "250px",
                                      boxShadow: "0 0 5px #ccc",
                                      borderRadius: "5px"
                                    }}
                                  />
                                </div>
                              </>
                            ) : formData?.n_type == 1 ? (
                              <>
                                <h4>Audio Preview</h4>
                                <audio controls src={fileimage} />
                              </>
                            ) : null}
                          </div>
                        ) : (
                          <div style={{ marginTop: "10px" }}>
                            {formData?.n_type == 0 &&
                            imageTypes?.includes(
                              formData?.n_image?.split(".").pop()?.toLowerCase()
                            ) ? (
                              <>
                                <h4>Image Preview</h4>
                                <div className="position-relative">
                                  <img
                                    src={`${Routes.API_HOSTNAME}images/notification/${formData?.n_image}`}
                                    alt="Uploaded file preview"
                                    style={{
                                      width: "450px",
                                      objectFit: "contain",
                                      height: "250px",
                                      boxShadow: "0 0 5px #ccc",
                                      borderRadius: "5px"
                                    }}
                                  />
                                </div>
                              </>
                            ) : formData?.n_type == 1 &&
                              videoTypes?.includes(
                                formData?.n_image?.split(".").pop()?.toLowerCase()
                              ) ? (
                              <>
                                <h4>Audio Preview</h4>
                                <audio
                                  controls
                                  src={`${Routes.API_HOSTNAME}images/notification/${formData?.n_image}`}
                                />
                              </>
                            ) : null}
                          </div>
                        ))}
                    </Grid>
                  )}
                  {formData?.n_type == 2 && (
                    <>
                      <Grid item xs={12}>
                        <Stack spacing={3}>
                          <TextField
                            required
                            type="text"
                            label="Video URL"
                            fullWidth
                            value={formData?.n_video}
                            onChange={(e) => {
                              setFormData({ ...formData, n_video: e.target.value });
                            }}
                          />
                        </Stack>
                      </Grid>
                      {/* Display Youtube URL */}
                      {formData?.n_video != "" && getYoutubeVideoId(formData?.n_video) != null && (
                        <Grid item xs={12}>
                          <div
                            className="rounded"
                            style={{
                              position: "relative",
                              height: "250px",
                              overflow: "hidden",
                              maxWidth: "100%"
                            }}
                          >
                            <p>hello</p>
                            <iframe
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "450px",
                                height: "250px"
                              }}
                              src={getYoutubeVideoId(formData?.n_video)}
                              title="YouTube video player"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                            />
                          </div>
                        </Grid>
                      )}
                    </>
                  )}
                  {/* Display Question and Answer */}
                  {formData?.n_type == 3 && (
                    <>
                      <Grid item xs={12}>
                        <Stack spacing={3}>
                          <TextField
                            required
                            type="text"
                            label="Question"
                            fullWidth
                            value={formData?.n_question}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                n_question: e.target.value
                              });
                            }}
                          />
                        </Stack>
                      </Grid>

                      <Grid item xs={12}>
                        <FormLabel> Answer</FormLabel>
                        <CKEditor
                          initData={formData?.n_answer}
                          config={{
                            allowedContent: true,
                            extraPlugins: "colorbutton,font", // adds font + color options
                            removeButtons: "", // keep all defaults
                            colorButton_colors:
                              // 🔹 Default CKEditor palette (taken from docs)
                              "000000,993300,333300,003300,003366,000080,333399,333333," +
                              "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                              "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                              "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                              "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                              // 🔹 Your extra theme colors (example: brand palette)
                              "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                          }}
                          onChange={(event) => {
                            const data = event.editor.getData();
                            setFormData((prevData) => ({
                              ...prevData,
                              n_answer: data
                            }));
                          }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <Stack spacing={3}>
                          <TextField
                            type="text"
                            label="URL"
                            fullWidth
                            value={formData?.n_link}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                n_link: e.target.value
                              });
                            }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={6}>
                        <Stack spacing={3}>
                          <TextField
                            type="text"
                            label="Button Title"
                            fullWidth
                            value={formData?.n_button_title}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                n_button_title: e.target.value
                              });
                            }}
                          />
                        </Stack>
                      </Grid>
                    </>
                  )}

                  {/* grid 6 add start date and end date */}
                  <Grid item xs={6}>
                    <Stack spacing={3}>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={enGB}
                        style={{ marginTop: "15px" }}
                      >
                        <DatePicker
                          type="date"
                          name="s_date"
                          label="Start Date "
                          inputFormat="dd/MM/yyyy"
                          value={
                            formData.s_date
                              ? new Date(formData.s_date.split("-").reverse().join("-"))
                              : null
                          }
                          minDate={new Date()}
                          onChange={(newDate) => {
                            // if (newDate) {
                            //   const formattedNewStart = moment(newDate, "DD-MM-YYYY").format(
                            //     "DD-MM-YYYY"
                            //   );

                            //   let updatedForm = {
                            //     ...formData,
                            //     s_date: formattedNewStart
                            //   };

                            //   // If end date is selected and it's less than new start date
                            //   if (
                            //     formData.e_date &&
                            //     moment(formData.e_date, "DD-MM-YYYY").isBefore(
                            //       moment(formattedNewStart, "DD-MM-YYYY")
                            //     )
                            //   ) {
                            //     updatedForm.e_date = "";

                            //     const notify = notification({
                            //       type: "error",
                            //       message: "End date cannot be less than start date."
                            //     });
                            //     notify();
                            //   }

                            //   setFormData(updatedForm);
                            // }
                            if (newDate instanceof Date && !isNaN(newDate)) {
                              const day = String(newDate.getDate()).padStart(2, "0");
                              const month = String(newDate.getMonth() + 1).padStart(2, "0");
                              const year = newDate.getFullYear();

                              const formattedNewStart = `${day}-${month}-${year}`;

                              let updatedForm = {
                                ...formData,
                                s_date: formattedNewStart
                              };

                              // Check end date
                              if (
                                formData.e_date &&
                                new Date(formData.e_date.split("-").reverse().join("-")) <
                                  new Date(formattedNewStart.split("-").reverse().join("-"))
                              ) {
                                updatedForm.e_date = "";

                                const notify = notification({
                                  type: "error",
                                  message: "End date cannot be less than start date."
                                });
                                notify();
                              }

                              setFormData(updatedForm);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} required onKeyDown={(e) => e.preventDefault()} />
                          )}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Stack spacing={3}>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={enGB}
                        style={{ marginTop: "15px" }}
                      >
                        <DatePicker
                          type="date"
                          name="e_date"
                          label="End Date "
                          inputFormat="dd/MM/yyyy"
                          // value={
                          //   formData.e_date != "" ? moment(formData.e_date, "DD-MM-YYYY") : null
                          // }
                          // minDate={
                          //   formData.s_date != ""
                          //     ? moment(formData.s_date, "DD-MM-YYYY").toDate()
                          //     : new Date()
                          // }
                          // onChange={(newDate) => {
                          //   if (newDate) {
                          //     setFormData({
                          //       ...formData,
                          //       e_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                          //     });
                          //   }
                          // }}
                          value={
                            formData.e_date
                              ? new Date(formData.e_date.split("-").reverse().join("-"))
                              : null
                          }
                          minDate={
                            formData.s_date
                              ? new Date(formData.s_date.split("-").reverse().join("-"))
                              : new Date()
                          }
                          onChange={(newDate) => {
                            if (newDate instanceof Date && !isNaN(newDate)) {
                              const day = String(newDate.getDate()).padStart(2, "0");
                              const month = String(newDate.getMonth() + 1).padStart(2, "0");
                              const year = newDate.getFullYear();

                              setFormData({
                                ...formData,
                                e_date: `${day}-${month}-${year}`
                              });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} required onKeyDown={(e) => e.preventDefault()} />
                          )}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Stack spacing={3}>
                      <RadioGroup
                        style={{ marginTop: "0px" }}
                        row
                        defaultValue={0}
                        value={formData?.notification_send_type}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            notification_send_type: e.target.value
                          });
                        }}
                        name="notification_send_type"
                      >
                        <FormControlLabel
                          value={0}
                          control={<Radio />}
                          label="Schedule Notification"
                        />
                        <FormControlLabel value={1} control={<Radio />} label="Send Immediately" />
                      </RadioGroup>
                    </Stack>
                  </Grid>
                  {formData?.notification_send_type == 0 && (
                    <Grid item xs={6}>
                      <Stack spacing={3}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          style={{ marginTop: "20px" }}
                        >
                          <DateTimePicker
                            type="date"
                            name="n_date_time"
                            label="Notification Send Date & Time"
                            inputFormat="dd/MM/yyyy hh:mm a"
                            value={
                              formData.n_date_time != ""
                                ? moment(formData.n_date_time, "DD-MM-YYYY hh:mm A").toDate()
                                : null
                            }
                            minDateTime={moment().startOf("minute").toDate()}
                            onChange={(newDate) => {
                              setFormData({
                                ...formData,
                                n_date_time: moment(newDate).format("DD-MM-YYYY hh:mm A")
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                onKeyDown={(e) => e.preventDefault()}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>
                  )}

                  {/* submit and rest form state */}
                  <Grid item xs={12} spacing={2}>
                    <LoadingButton
                      type="button"
                      variant="contained"
                      color="primary"
                      sx={{ marginRight: "5px" }}
                      loading={isFormSubmit}
                      onClick={() => handleFormSubmit()} // handleFormSubmit function
                    >
                      Submit
                    </LoadingButton>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        resetFormData();
                        setPage(0);
                        setfileimage();
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </>
          ) : (
            <>
              <Card className="p-20 mb-15">
                <Grid container spacing={2} sx={{ alignItems: "center" }}>
                  <Grid item xs={2}>
                    <Stack>
                      <label>Notification Status</label>
                      <Select
                        menuPortalTarget={document.body}
                        value={NotificationStatus.map((c) => {
                          if (c.value == filtereddata.notificationStatus) {
                            return { value: c.value, label: c.label };
                          }
                        })}
                        onChange={(e) => {
                          setFilteredData({
                            ...filtereddata,
                            notificationStatus: e.value
                          });
                        }}
                        options={NotificationStatus}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={3}>
                    <Stack>
                      <label>Notification Type</label>
                      <Select
                        menuPortalTarget={document.body}
                        value={NotificationType.map((c) => {
                          if (c.value == filtereddata.notificationType) {
                            return { value: c.value, label: c.label };
                          }
                        })}
                        onChange={(e) => {
                          setFilteredData({
                            ...filtereddata,
                            notificationType: e.value
                          });
                        }}
                        options={NotificationType}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={3}>
                    <Stack>
                      <label>Notification To</label>
                      <Select
                        menuPortalTarget={document.body}
                        value={NotificationTo.map((c) => {
                          if (c.value == filtereddata.n_to) {
                            return { value: c.value, label: c.label };
                          }
                        })}
                        onChange={(e) => {
                          setFilteredData({
                            ...filtereddata,
                            n_to: e.value
                          });
                        }}
                        options={NotificationTo}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={3}>
                    <Stack spacing={10}>
                      <TextField
                        style={{ marginTop: "0px" }}
                        fullWidth
                        autoComplete="off"
                        type="text"
                        label="Search"
                        name="name"
                        autoCorrect="off"
                        value={filtereddata.search}
                        onChange={(e) => {
                          setFilteredData({
                            ...filtereddata,
                            search: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>

                  <Grid
                    item
                    xs={1}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end"
                    }}
                  >
                    <Button
                      onClick={async () => {
                        setFilteredData({
                          notificationFor: -1,
                          notificationStatus: 0,
                          n_to: 0,
                          notificationType: -1,
                          search: "",
                          startDate: "",
                          endDate: ""
                        });
                      }}
                      variant="contained"
                    >
                      clear
                    </Button>
                  </Grid>
                </Grid>
              </Card>
              <Card className="p-2" style={{ padding: "15px" }}>
                <Button className="btn btn-export">
                  <CSVLink
                    data={formattedCSVData}
                    headers={expo_columns}
                    filename={"Notification.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                {notificationList && (
                  <>
                    <DataTable
                      filter
                      pagination
                      highlightOnHover
                      columns={columns}
                      data={newNotificationList != null && newNotificationList}
                      expandableRows
                      expandableRowsComponent={ExpandableRow}
                      progressPending={isLoading}
                      progressComponent={<CustomLoader />}
                    />
                  </>
                )}
              </Card>
            </>
          )}

          <Modal
            open={readNotificationDataModal}
            onClose={closeModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={readNotificationModalStyle}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginBottom: "5px", textAlign: "center" }}
              >
                Notification Read By Members
              </Typography>
              <hr />

              <Stack style={{ marginBottom: "10px", marginTop: "10px" }}>
                <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={4}></Grid>
                  <Grid item xs={2}>
                    <Button className="btn btn-export">
                      <CSVLink
                        data={readNotificationList}
                        headers={export_readNotificationDetailColumns}
                        filename={`Notification Read Date.csv`}
                        className="btn btn-primary test"
                        target="_blank"
                      >
                        Export CSV
                      </CSVLink>
                    </Button>
                  </Grid>
                </Grid>
                <Card>
                  <DataTable
                    filter
                    fixedHeaderScrollHeight="450px"
                    fixedHeader={true}
                    pagination
                    highlightOnHover
                    columns={readNotificationDetailColumns}
                    data={readNotificationList}
                    progressPending={isLoading2}
                    progressComponent={<CustomLoader />}
                  />
                </Card>
              </Stack>
              <hr />
              <div
                style={{
                  margin: "10px  auto 0",
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <Button
                  variant="outlined"
                  onClick={closeModal}
                  style={{ marginTop: "0px", marginRight: "0px" }}
                >
                  Close
                </Button>
              </div>
            </Box>
          </Modal>
        </Container>
      </Page>
    </>
  );
}

export default Notification;
